export var TimePickerDropdownTestIds = {
    /** Test ID to grab the root element (the dropdown trigger) */
    ROOT: 'hawkins-time-picker-dropdown-root',
};
